import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { NewNicaFormComponent } from '../../nica-form/new-nica-form.component';
import { HttpClient } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { AnagraficaService } from '../../../services/anagrafica.service';
import { Apiservice } from '../../../services/api.service';
import { ComponentService } from '../../../services/component.service';
import { GetFilterService } from '../../../services/get-filter.service';
import { ModelliStampaService } from '../../../services/modelli-stampa.service';
import { UtilityService } from '../../../services/utility.service';
import { alert } from 'devextreme/ui/dialog';
import * as moment from "moment";
import { Contatto } from '../crm-contatti/interfaces';
import { environment } from '../../../../environments/environment';
import notify from 'devextreme/ui/notify';
import { Subject } from 'rxjs';
import { takeUntil, filter, throttleTime } from 'rxjs/operators';
moment.locale('it');

@Component({
  selector: 'app-stampa-contratto',
  templateUrl: './stampa-contratto.component.html',
  styleUrls: ['./stampa-contratto.component.css']
})
export class StampaContrattoComponent implements OnInit {

  @ViewChild('stampaContratto', { static: true }) stampaContratto: NewNicaFormComponent;

  @Input() api_template: string = '';
  @Input() api_rest: boolean = true;
  @Input() remoteOperation: boolean = false;
  @Input() guidPopUp;
  @Input() filterEditor = `/`;
  @Input() filterList = "";
  @Input() formActionType = "edit";
  @Input() formType = "simple";
  @Input() idTabRif = [];
  @Input() isEdit = false;
  @Input() masterKey = 'id';
  @Input() nCol = 2;
  @Input() queryFilter = [];
  @Input() service = "crmStampaContrattoForm";
  @Input() standardBtnBottom = [22, 23];
  @Input() CustomButtonSetForm;
  @Input() dataJson;
  @Input() contatto: Contatto;

  dataFinale: any[] = [];
  private destroy$ = new Subject<void>();
  private popupClose$ = new Subject<void>();
  private isPopupInvioContrattoAperto = false;
  constructor(
    private userComponentService: ComponentService,
    private api: Apiservice,
    private anagraficaService: AnagraficaService,
    private spinner: NgxSpinnerService,
    private getFilter: GetFilterService,
    private cdr: ChangeDetectorRef,
    private utilityService: UtilityService,
    private stampaPdfService: ModelliStampaService,
    private httpClient: HttpClient
  ) { }

  ngOnInit() {
    this.userComponentService.eventoToolbarObs$
      .pipe(takeUntil(this.destroy$))
      .subscribe(event => {
        switch (event) {
          case 'inviaContratto':
            this.openPopupInvioContrattoSafe();
            break;
        }
      });
  }


  private openPopupInvioContrattoSafe() {
    if (this.isPopupInvioContrattoAperto) {
      console.warn('Popup invio contratto già aperto — ignoro evento.');
      return;
    }

    this.isPopupInvioContrattoAperto = true;
    this.apriPopupInvioContratto();
  }


  ngOnDestroy() {
    // this.destroy$.next();
    // this.destroy$.complete();
  }


  eventsForm(res) {
    if (res.name === "onValueChanged") {
      if (res.campo.dataField === "procedura" && res.value !== "") {
        const campi = [
          'informazioniSedeOperativa.personaDaContattare',
          'informazioniSedeOperativa.indSpedizioneOp',
          'informazioniSedeOperativa.frazioneOp',
          'informazioniSedeOperativa.id_provincia',
          'informazioniSedeOperativa.locOp',
          'informazioniSedeOperativa.capOp'
        ];
        campi.forEach(c => res.masterComponent.itemOption(c, 'disabled', false));
      }
      this.cdr.detectChanges()
    }
  }

  apriPopupInvioContratto() {
    const guidInviaContratto = Math.random().toString().replace('0.', '');
    const titoloPopup = 'Invia contratto';

    const instanceData = {
      api_template: ``,
      api_rest: true,
      guidPopUp: guidInviaContratto,
      remoteOperation: false,
      filterEditor: `/`,
      filterList: "",
      formActionType: "edit",
      formType: "simple",
      idTabRif: [],
      isEdit: false,
      masterKey: 'id',
      queryFilter: [],
      service: "crmInviaContrattoForm",
      standardBtnBottom: [22, 23],
      dataJson: {
        nome: this.contatto.nomeSignBook,
        cognome: this.contatto.cognomeSignBook,
        cf: this.contatto.cfSignBook,
        mail: this.contatto.mailSignBook,
        cell: this.contatto.cellSignBook
      }
    };

    this.userComponentService.setNewPopUp(
      guidInviaContratto,
      'NewNicaFormComponent',
      false,
      '500',
      null,
      instanceData,
      false,
      true,
      titoloPopup,
      'top'
    );

    const popupClose$ = new Subject<void>();

    this.userComponentService.outputComponent
      .pipe(
        takeUntil(popupClose$),
        filter(res => res.guid === guidInviaContratto)
      )
      .subscribe(async (res) => {
        if (res.name === "submitFormStatic") {
          await this.inviaContratto(res, guidInviaContratto);
          popupClose$.next();
        }

        if (res.name === "return" || res.name === "close") {
          this.userComponentService.destroyCurrentOpenPopUpByGuid(guidInviaContratto);
          this.isPopupInvioContrattoAperto = false;
          this.destroy$.next();
          this.destroy$.complete();
          popupClose$.next();
        }
      });
  }

  async emittendButtonPush(res) {
    if (res.name === "beforSave") {
      if (res.formData.personaDaContattare === undefined)
        res.formData.personaDaContattare = '';

      let newArray = [];
      let moduliFiltrati = [];
      let prezzoTotale: number = 0;
      const codiceContratto = res.formData.codiceContratto.split('');
      let procedura = [...res.formData][0];
      let moduli = [...res.formData.moduli];
      const rate = res.formData.rate === "" ? "1" : res.formData.rate;

      console.log(procedura.dataAttivazione)
      console.log(procedura.dataScadenza)
      procedura.dataAttivazione = moment(procedura.dataAttivazione).format('DD-MM-YYYY');
      procedura.dataScadenza = moment(procedura.dataScadenza).format('DD-MM-YYYY');

      for (let i = 0; i < codiceContratto.length; i++) {
        res.formData[`codiceContratto${i}`] = codiceContratto[i];
      }

      if (rate.includes("§")) {
        const splitRate = rate.split("§");
        const mesi = splitRate.map((item) => {
          const mese = parseInt(item, 10) - 1;
          if (mese >= 0 && mese <= 11) {
            return moment().month(mese).format('MMMM');
          } else {
            console.warn(`Valore mese non valido: ${item}`);
            return null;
          }
        });
        procedura.rate = mesi.map(item => item.toUpperCase()).join(' / ');
      } else {
        procedura.rate = moment().month(0).format('MMMM').toUpperCase();
      }

      if (moduli && moduli.length > 0) {
        moduliFiltrati = moduli.filter(item =>
          item.procedura_attiva != 0 && item.escludiContratto != 1
        );
      }

      delete procedura.moduli;

      if (moduliFiltrati.length !== 0) {
        const raggruppati = Object.values(
          moduliFiltrati.reduce((acc, item) => {
            const key = `${item.CodModulo}||${item.Assistenza}`;
            if (!acc[key]) {
              acc[key] = { ...item };
            } else {
              acc[key].quantita += item.quantita;
            }
            return acc;
          }, {})
        );
        newArray = [...procedura, ...raggruppati];
      } else {
        newArray = [...procedura];
      }

      newArray.forEach(item => {
        const quantita = item.quantita === undefined ? 1 : item.quantita;
        const assistenza = item.Assistenza;
        prezzoTotale += parseFloat(assistenza.replace(',', '.')) * parseInt(quantita);
      });

      newArray = newArray.map((item, index) => {
        const prezzoInLettere =
          parseInt(item.Assistenza) !== 0
            ? this.utilityService.numeroInLetterePrezzo(this.checkNumber(item.Assistenza)).replace(/\s+/g, '')
            : null;

        const updatedItem = {
          ...item,
          prezzoTotale: new Intl.NumberFormat('it-IT', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(prezzoTotale)
        };

        if (index === 0) {
          updatedItem.desFull = item.procedura;
          updatedItem.importoInLettereFull = prezzoInLettere;
          updatedItem.quantitaFull = parseInt(item.quantita).toFixed();
          updatedItem.assistenzaFull = this.checkNumber(item.Assistenza);
        } else {
          updatedItem.desFull = item.des;
          updatedItem.importoInLettereFull = prezzoInLettere;
          updatedItem.quantitaFull = parseInt(item.quantita).toFixed();
          updatedItem.assistenzaFull = this.checkNumber(item.Assistenza);
          delete updatedItem.rate;
        }

        return updatedItem;
      });

      this.dataFinale = newArray.map(item => {
        const newItem: { [key: string]: any } = {};
        for (const key in item) {
          if (item.hasOwnProperty(key)) {
            newItem[`contratto_${key}`] = item[key];
          }
        }
        return newItem;
      });
    }

    if (res.name === "submitFormStatic") {
      let button = environment.enable ? [29] : []
      this.generaStampaContratto(this.dataFinale.slice(0, 15), 'preview', button);
      this.popupClose$.next();
      this.userComponentService.destroyCurrentOpenPopUpByGuid(this.guidPopUp);

    }

    if (res.name === 'return') {
      this.userComponentService.destroyCurrentOpenPopUpByGuid(this.guidPopUp);
    }
  }

  private async inviaContratto(res: any, guid: string) {
    try {
      const base64 = await this.generaStampaContratto(this.dataFinale.slice(0, 15), 'base64String');
      if (!base64) return alert("Errore durante l'invio del contratto", 'Attenzione!');

      const mockObj = {
        User: "",
        Password: "",
        Company: "047",
        m_UserName: environment.m_UserName,
        m_Password: environment.m_Password,
        m_Company: environment.m_Company,
        files: {
          files: [
            {
              fileId: "1",
              fileDescri: "",
              fileName: `CONTRATTO_${res.data.cognome.toUpperCase()}_${res.data.nome.toUpperCase()}.pdf`,
              fileB64: base64,
              signatures: [
                // {
                //   // firma in alto a sinistra
                //   fiscalCodeSigner: environment.codfisc_fir2,
                //   pageNumber: 2,
                //   x: 16.5,
                //   y: 496,
                //   width: 180,
                //   height: 11
                // },
                {
                  // firma in alto a destra
                  fiscalCodeSigner: `${res.data.cf}`,
                  pageNumber: 2,
                  x: 366.8,
                  y: 495,
                  width: 180,
                  height: 30
                },
                // {
                //   // firma in basso a sinistra
                //   fiscalCodeSigner: environment.codfisc_fir2,
                //   pageNumber: 2,
                //   x: 25,
                //   y: 98,
                //   width: 180,
                //   height: 11
                // },
                {
                  // firma in basso a destra
                  fiscalCodeSigner: `${res.data.cf}`,
                  pageNumber: 2,
                  x: 330,
                  y: 105,
                  width: 205,
                  height: 30
                },
              ]
            },
          ]
        },
        rif_ext: this.contatto.PIva + Date.now(),
        tipo_pratica: "006",
        descr_pratica: `contratto di ${this.contatto.RagSoc}, inviato a ${res.data.nome.toUpperCase()} ${res.data.cognome.toUpperCase()} in data ${new Date().toLocaleDateString('it-IT')}`,
        codfisc_op: environment.codfisc_op,
        nome_op: environment.nome_op,
        cognome_op: environment.cognome_op,
        email_op: environment.email_op,
        invmailcompl_op: "N",
        codfisc_cl: `${res.data.cf.toUpperCase()}`,
        nome_cl: `${res.data.nome.toUpperCase()}`,
        cognome_cl: `${res.data.cognome.toUpperCase()}`,
        email_cl: `${res.data.mail.toUpperCase()}`,
        cell_cl: `${res.data.cell}`,
        invmail_cl: "S",
        invsms_cl: "S",
        codfisc_fir2: environment.codfisc_fir2,
        nome_fir2: environment.nome_fir2,
        cognome_fir2: environment.cognome_fir2,
        email_fir2: environment.email_fir2,
        cell_fir2: environment.cell_fir2,
        invmail_fir2: "N",
        invsms_fir2: "N",
        download_docs: "S",
        showWelcome: "N",
        cod_cat: "005",
        sendtocodi: "N",
        optParam: {
          options: {
            signedCopy: {
              send: true
            },
            courtesyCopy: {
              send: false,
              email: [""]
            }
          }
        }
      }

      this.spinner.show();
      const risposta: any = await this.api.PostApi('SignBook/CreaPraticaV2/', mockObj, 'application/json');
      if (risposta.status === 'OK') {
        notify({ message: 'Contratto inviato', height: 45, width: 250, position: 'center center' }, 'success', 3000);
      } else {
        notify({ message: 'Errore durante l\'invio del contratto', height: 45, width: 250, position: 'center center' }, 'error', 3000);
      }
    } catch (error) {
      alert("Errore durante l'invio del contratto", 'Attenzione!');
    } finally {
      this.spinner.hide();
      try {
        this.userComponentService.destroyCurrentOpenPopUpByGuid(guid);
      } catch (err) {
        console.warn(`Popup ${guid} già chiuso o non trovato`);
      }
    }
  }

  async generaStampaContratto(data: any, option: 'download' | 'preview' | 'base64String', standardBtnBottom: Array<number> = []): Promise<any> {
    if (!data) {
      console.error('Dati non validi per la generazione del contratto');
      throw new Error('Dati non validi');
    }

    const pagineArrayBuffer: ArrayBuffer[] = [];

    try {
      const contratto_page_1: any = await this.api.GetApi('ModellodiStampa/GetByGUID/28ebd5c3-5f61-428b-9966-cdddc9eef9a8');
      const contratto_page_2: any = await this.api.GetApi('ModellodiStampa/GetByGUID/0b8d1c79-c770-4307-8a13-75e54810411b');

      if (contratto_page_1) {
        pagineArrayBuffer[0] = await this.stampaPdfService.generaPDF(data, contratto_page_1, 'arraybuffer', false) as ArrayBuffer;
      }

      if (contratto_page_2) {
        pagineArrayBuffer[1] = await this.stampaPdfService.generaPDF(data, contratto_page_2, 'arraybuffer', false) as ArrayBuffer;
      }

      if (pagineArrayBuffer.length === 0 || !pagineArrayBuffer[0] || !pagineArrayBuffer[1]) {
        throw new Error('Errore nella generazione delle pagine PDF');
      }

      const res = await this.stampaPdfService.mergePDFMultipli(pagineArrayBuffer, option, standardBtnBottom);
      console.log(res)
      if (typeof res === 'string') {
        return res;
      }

    } catch (error) {
      alert('Errore durante la generazione del contratto', 'Attenzione!')
      console.error('Errore durante la generazione del contratto:', error);
    }
  }

  checkNumber(assistenza) {
    let formatAssistenza = assistenza.includes(',') ? assistenza : assistenza + ',00';
    return formatAssistenza;
  }
}
